import React from 'react';
import { Link } from 'react-router-dom';
import { Truck, Facebook, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1a1a1a] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Logo and Description */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center space-x-3 mb-6 group">
              <img 
                src="https://customer-assets.emergentagent.com/job_flying-cargo/artifacts/o156lbn9_600887873_1449698483828339_6269059536743983543_n.jpg"
                alt="JIT Cargo Services"
                className="h-16 w-16 rounded-full object-cover transition-transform group-hover:scale-105"
              />
              <div className="flex flex-col">
                <span className="font-bold text-xl leading-tight text-white">JIT CARGO</span>
                <span className="text-sm text-gray-400 leading-tight">Just In Time Services</span>
              </div>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Fast, reliable cargo delivery services across the Philippines. Same-day and next-day delivery options available.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 hover:bg-[#D62828] flex items-center justify-center transition-colors duration-200">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 hover:bg-[#D62828] flex items-center justify-center transition-colors duration-200">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 hover:bg-[#D62828] flex items-center justify-center transition-colors duration-200">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-base mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#D62828] text-sm transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/track" className="text-gray-400 hover:text-[#D62828] text-sm transition-colors duration-200">
                  Track Shipment
                </Link>
              </li>
              <li>
                <Link to="/history" className="text-gray-400 hover:text-[#D62828] text-sm transition-colors duration-200">
                  My Shipments
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-base mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 text-[#D62828] mt-1" />
                <a href="mailto:info@jitcargo.com" className="text-gray-400 hover:text-[#D62828] text-sm">
                  info@jitcargo.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 text-[#D62828] mt-1" />
                <a href="tel:+639123456789" className="text-gray-400 hover:text-[#D62828] text-sm">
                  +63 912 345 6789
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-[#D62828] mt-1" />
                <span className="text-gray-400 text-sm">
                  Manila, Philippines
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="text-center">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} JIT Cargo Services. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
